import React from 'react';
import { calculateEstimatedReadTime } from '@helpers/estimatedReadTime';
import { formatDate } from '@helpers/miscelleanous';
import useHashScroll from '@hooks/useHashScroll';
function BlogMetaInfo({ blogDetails, categories }) {
    const readTime = calculateEstimatedReadTime(blogDetails?.content);
    const { scrollToHashElement } = useHashScroll(100, 40);
    return (
        <>
            <section className="text-gray-900 text-xs md:text-sm xl:text-base w-full flex flex-row justify-between gap-6">
                <ul className="flex flex-col md:flex-row gap-1 md:gap-6 lg:gap-8 w-3/4 md:w-auto">
                    <li className="">{categories}</li>
                    <li className="min-w-[80px]">
                        {blogDetails && `${readTime} min read`}
                    </li>
                </ul>
                <ul className="flex flex-col md:flex-row gap-1 md:gap-2 font-semibold min-w-[120px] md:min-w-[145px]">
                    {blogDetails?.author?.node?.name ? <li>By <span className='text-primary-500 underline cursor-pointer' onClick={() => scrollToHashElement('author-details')}>{blogDetails?.author?.node?.name}</span></li> : null}
                    {blogDetails?.author?.node?.name && blogDetails?.date && (
                        <li className="hidden md:block">{`|`}</li>
                    )}
                    <li className="">
                        {blogDetails?.date && formatDate(blogDetails?.date)}
                    </li>
                </ul>
            </section>
        </>
    );
}

export default BlogMetaInfo;
